"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _makeStyles = _interopRequireDefault(require("../styles/makeStyles"));

var styles = function styles(theme) {
  return {
    root: {
      position: 'relative',
      width: theme.spacing(3),
      height: theme.spacing(3),
      '&::before': {
        opacity: 1,
        content: '""',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: theme.spacing(3),
        height: theme.spacing(3),
        borderWidth: 2,
        borderStyle: 'solid',
        borderColor: theme.palette.grey[400],
        borderRadius: '50%',
        transition: theme.transitions.create('opacity', {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.shortest
        })
      },
      '&::after': {
        opacity: 0,
        content: '""',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%) scale(.25)',
        width: theme.spacing(3),
        height: theme.spacing(3),
        borderWidth: 8,
        borderStyle: 'solid',
        borderColor: theme.palette.primary.main,
        borderRadius: '50%',
        transition: theme.transitions.create(['transform', 'opacity'], {
          easing: theme.transitions.easing.easeInOut,
          duration: theme.transitions.duration.standard
        })
      }
    },
    checked: {
      '&::before': {
        opacity: 0
      },
      '&::after': {
        opacity: 1,
        transform: 'translate(-50%, -50%) scale(1)'
      }
    }
  };
};

exports.styles = styles;
var useStyles = (0, _makeStyles["default"])(styles);

var RadioIcon = function RadioIcon(_ref) {
  var checked = _ref.checked;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])(classes.root, (0, _defineProperty2["default"])({}, classes.checked, checked))
  });
};

var _default = RadioIcon;
exports["default"] = _default;